import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';
import { Account } from '../components/UpsertGrantModal/UpsertGrantModal.meta';

interface FetcherParams {
  clientId: string;
  account: Account;
}

const saveAccount = ({ clientId, account }: FetcherParams) => {
  return authFetch('/Consumer/AccountUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions({ clientId, accountType: '24', ...account }, true),
  });
};

interface Params {
  clientId: string;
}

export const useSaveAccountMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(saveAccount, {
    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.stockOptions(clientId));
    },
  });
};
